import React from "react";
import { useTranslation } from "react-i18next";
import { HiArrowTopRightOnSquare } from "react-icons/hi2";
import { Link } from "react-router-dom";

import Logo from "./Logo";

import footerContent from "../../content/footer";

const Footer = () => {
  const { t } = useTranslation(["footer", "navigation"]);
  const currentYear = new Date().getFullYear();

  const renderFooterLink = (link, index) => {
    const linkLabel = t(link.LABEL, { ns: "navigation" });

    if (link.EXTERNAL) {
      return (
        <a
          className="group inline-flex items-center gap-2 text-sm text-slate-700 transition hover:text-sky-600"
          href={link.PATH}
          key={`${link.VALUE}-${index}`}
          rel="noopener noreferrer"
          target="_blank"
        >
          <span>{linkLabel}</span>
          <HiArrowTopRightOnSquare className="text-sm text-slate-400 transition group-hover:text-sky-500" />
        </a>
      );
    }

    return (
      <Link
        className="inline-flex items-center gap-2 text-sm text-slate-700 transition hover:text-sky-600"
        key={`${link.VALUE}-${index}`}
        to={link.PATH}
      >
        <span>{linkLabel}</span>
      </Link>
    );
  };

  return (
    <footer className="w-full bg-[rgba(217,231,255,0.5)] px-4 py-10 sm:px-6 lg:px-8 lg:py-14">
      <div className="mx-auto flex max-w-8xl flex-col gap-8">
        <Logo />

        <div className="flex flex-col md:flex-row space-y-8 md:space-y-0 space-x-0 md:space-x-24">
          <div className="flex flex-col space-y-6">
            <div className="flex flex-col gap-2 sm:flex-row sm:gap-6">
              <p className="min-w-16 text-sm font-semibold text-slate-900">
                {t("addressLabel", { ns: "footer" })}
              </p>
              <div className="space-y-1 text-sm text-slate-700">
                {footerContent.addressLines.map((line) => (
                  <p key={line}>{line}</p>
                ))}
              </div>
            </div>

            <div className="flex flex-col gap-2 sm:flex-row sm:gap-6">
              <p className="min-w-16 text-sm font-semibold text-slate-900">
                {t("emailLabel", { ns: "footer" })}
              </p>
              <a
                className="text-sm text-slate-700 transition hover:text-sky-600"
                href={`mailto:${footerContent.email}`}
              >
                {footerContent.email}
              </a>
            </div>
          </div>

          <div className="grid gap-3 lg:gap-24 grid-cols-2 lg:grid-cols-4">
            {footerContent.navigationGroups.map((group, index) => (
              <div className="flex flex-col gap-1" key={index}>
                {group.map(renderFooterLink)}
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-slate-300 pt-5"></div>

        <p className="text-sm text-slate-600 lg:text-right">
          {t("copyright", { ns: "footer", year: currentYear })}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
